import '../styles/product.css';
import { useNavigate } from 'react-router-dom';

function Product() {
    const navigate = useNavigate();
    return (
        <div className="product-page">
            <section className="container product-header">
                <h1>Fleetify Product Overview</h1>
                <p>Your all-in-one platform to manage car rentals efficiently, professionally, and profitably.</p>
            </section>

            <section className="product-section">
                <div className="container product-grid">
                    <div className="product-feature">
                        <h2>Centralized Dashboard</h2>
                        <p>Track bookings, payments, customer info, and vehicle status from one intuitive interface.</p>
                    </div>
                    <div className="product-feature">
                        <h2>Smart Pricing Engine</h2>
                        <p>Automatically adjust rates based on demand, location, age, and season to maximize profit.</p>
                    </div>
                    <div className="product-feature">
                        <h2>Automated Reminders</h2>
                        <p>Reduce no-shows with customizable SMS and email reminders for bookings, returns, and maintenance.</p>
                    </div>
                    <div className="product-feature">
                        <h2>Fleet Management Tools</h2>
                        <p>Monitor mileage, service history, and rental activity to keep your fleet optimized and road-ready.</p>
                    </div>
                </div>
            </section>

            <section className="product-cta">
                <div className="container">
                    <h2>Built to Scale with Your Business</h2>
                    <p>From startups to established rental agencies - Fleetify is flexible, powerful, and ready to grow with you.</p>
                    <button
                        className="btn-primary"
                        onClick={() => navigate('/sales')}
                    >
                        Book a Free Demo
                    </button>
                </div>
            </section>
        </div>
    );
}

export default Product;
